/**
 * Rettet einen angefangenen Kommentar-Entwurf über den Seiten-Reload hinweg,
 * der nach erfolgreichem Login/Registrierung im Login-Overlay ausgelöst wird.
 * Rein clientseitige Komfort-Funktion (sessionStorage) ohne jede Sicherheitsrelevanz -
 * das serverseitige Login-Gate für das Absenden von Kommentaren bleibt unberührt.
 */
import { safeSelect } from './utils.js';

const STORAGE_KEY = 'secretnews:commentDraft';

function stashDraft() {
	const commentForm = document.getElementById('comment-form');
	if (!commentForm) return;

	const textarea = safeSelect('#field-text', commentForm);
	const articleIdInput = commentForm.querySelector('input[name="article_id"]');
	const text = textarea?.value?.trim();
	if (!text || !articleIdInput) return;

	try {
		sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ articleId: articleIdInput.value, text }));
	} catch (error) {
		console.error('Kommentar-Entwurf konnte nicht zwischengespeichert werden:', error);
	}
}

function restoreDraft() {
	let raw;
	try {
		raw = sessionStorage.getItem(STORAGE_KEY);
	} catch (error) {
		return;
	}
	if (!raw) return;

	try {
		sessionStorage.removeItem(STORAGE_KEY);
	} catch (error) { /* ignore */ }

	try {
		const { articleId, text } = JSON.parse(raw);
		const commentForm = document.getElementById('comment-form');
		const articleIdInput = commentForm?.querySelector('input[name="article_id"]');
		if (!commentForm || !articleIdInput || articleIdInput.value !== articleId) return;

		const textarea = safeSelect('#field-text', commentForm);
		if (!textarea) return;

		textarea.value = text.slice(0, 1000);
		textarea.dispatchEvent(new Event('input', { bubbles: true })); // aktualisiert den Zeichenzähler
		textarea.scrollIntoView({ behavior: 'smooth', block: 'center' });
		textarea.focus();
	} catch (error) {
		console.error('Kommentar-Entwurf konnte nicht wiederhergestellt werden:', error);
	}
}

export function initCommentDraftPersistence() {
	try {
		document.addEventListener('submit', function(e) {
			if (e.target.matches('.form--login, .form--register')) {
				stashDraft();
			}
		});

		restoreDraft();
	} catch (error) {
		console.error('Fehler bei der Initialisierung der Kommentar-Entwurfsrettung:', error);
	}
}
